window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Sparkle.MobileCTA.CTA = class CTA {
  constructor(cta) {
    this.truncatedTitle = this.truncatedTitle.bind(this);
    this.activate = this.activate.bind(this);
    this.element = jQuery(cta);
    this.elementId = this.element.attr("id");
    this.elementType = this.element.attr("data-cta");
    this.title = this.element.attr("data-cta-teaser-button-text") || this.element.find("header").first().text();
  }

  // DSL

  truncatedTitle() {
    const stringLimit = 58;
    const { title } = this;
    if (title.length < stringLimit) {
      return title;
    }

    return title.substring(0, stringLimit - 1) + "...";
  }

  activate() {}
};
// no-op
